const InputTimePciker = ({ startTime, t }) => {
    return (`

    <div class="blue-bar">
        <div class='main-back-blue-bar close_time_picker'>
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewbox="0 0 10 6">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
            fill="currentColor">
        </path>
    </svg>
            <p>` + t("modal-back-blue-bar") + `</p>
        </div>
    </div>
    <div class="timepicker-input--wrapper">
        <div class="search_col recogida_time">
            <div class="small-heading">
                <h4 id="hour_marker">Hora de recogida</h4>

            </div>
            <div class="address_main">
                <svg class="time_icon" xmlns="http://www.w3.org/2000/svg" id="Icon-Time" width="21"
                    height="21" viewBox="0 0 21 21">
                    <rect id="Safe" width="21" height="21" fill="none" />
                    <g id="Icon">
                        <path id="Path"
                            d="M13372,22338.752a8.75,8.75,0,1,1,8.749,8.748A8.76,8.76,0,0,1,13372,22338.752Zm1.3,0a7.448,7.448,0,1,0,7.447-7.449A7.459,7.459,0,0,0,13373.3,22338.752Zm11.536,3.105-4.414-2.545a.654.654,0,0,1-.325-.561v-5.553a.651.651,0,1,1,1.3,0v5.182l4.083,2.35a.65.65,0,0,1-.324,1.215A.615.615,0,0,1,13384.839,22341.857Z"
                            transform="translate(-13370.25 -22328.25)" stroke="rgba(0,0,0,0)"
                            strokeWidth="1" />
                    </g>
                </svg>
                <div>
                    <input id="timepickerPopupInput" class="timepicker" placeholder="09:00 am" value="${startTime[1]}"/>
                </div>
            </div>
        </div>

    </div>
    <div class="container_time_bar">
        <div class="time_bar_div">Recogida</div>
        <div class="time_bar_div">Devolución</div>
    </div>


    `);
};
export default InputTimePciker;
